const romanCharactersAndNumbersOnly = (value) => {
  const pattern = /^[A-Za-z0-9\s.,'\-]+$/;
  
  if (!(pattern.test(value))) {
    return 'errors.formFields.aToZAndNumbersOnly';
  }
};

export default romanCharactersAndNumbersOnly;
